const BASE_ROUTE = "/role";

const ROLES_URLS = { 
    GET_ALL: BASE_ROUTE + "/get_all",
    UPDATE: BASE_ROUTE + "/update",
    INSERT: BASE_ROUTE + "/insert",
    GET_ONE: BASE_ROUTE + "/get_one",
    DELETE: BASE_ROUTE + "/delete_one",
    GET_USER_BY_ROLE: BASE_ROUTE + "/get_users_by_role",
  };
  
  export {
    ROLES_URLS
  };